module.exports = __webpack_public_path__ + "static/aufgabenerfassung-290272dd9bd7cab85c00f587873c760d.jpg";